import { render, staticRenderFns } from "./icon-cart.vue?vue&type=template&id=6b863d80&scoped=true&"
import script from "./icon-cart.vue?vue&type=script&lang=js&"
export * from "./icon-cart.vue?vue&type=script&lang=js&"
import style0 from "./icon-cart.vue?vue&type=style&index=0&id=6b863d80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b863d80",
  null
  
)

export default component.exports